import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAP_RATING_COLORS } from '../../../constants/colors';
import './RatingLegend.css';

export const legendItems = [
  { label: 'AAA', color: MAP_RATING_COLORS.AAA, range: '89+' },
  { label: 'AA', color: MAP_RATING_COLORS.AA, range: '78-88' },
  { label: 'A', color: MAP_RATING_COLORS.A, range: '68-77' },
  { label: 'BBB', color: MAP_RATING_COLORS.BBB, range: '57-67' },
  { label: 'BB', color: MAP_RATING_COLORS.BB, range: '48-56' },
  { label: 'B', color: MAP_RATING_COLORS.B, range: '<48' },
  { label: 'N/A', color: MAP_RATING_COLORS['N/A'], range: 'No data' },
];

const RatingLegend: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="rating-legend">
      <h4>{t('map.averageScore')}</h4>
      <div className="legend-items">
        {legendItems.map((item) => (
          <div key={item.label} className="legend-item">
            <span
              className="legend-color"
              style={{ backgroundColor: item.color }}
            />
            <span className="legend-range">{item.range}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingLegend;
